// extracted by mini-css-extract-plugin
export default {"container":"tag_container__0OUTX","close":"tag_close__TI0mM"};